//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ColumnSection',
  props: {
    heading: {
      type: String,
      required: true,
    },
    isCardLayout: {
      type: Boolean,
      default: false,
    },
    cardClasses: {
      type: String,
      default: '',
    },
  },
};
